











































































































































































































import GlowModal from '@/components/GlowModal.vue';
import PlanUpgradeModalTab from '@/components/modals/PlanUpgrade/PlanUpgradeModalTab.vue';
import usePlanUpgrade, {
  PricePoint,
  PRODUCT_DISPLAY_NAMES,
} from '@/hooks/usePlanUpgrade/usePlanUpgrade';
import {
  TypeBody,
  BaseDivider,
  BaseButton,
  BlockSelector,
  BaseIcon,
  BaseLink,
  AnnularThrobber,
} from '@bambeehr/pollen';
import {
  ref,
  computed,
  ComputedRef,
  defineComponent,
  watch,
} from '@nuxtjs/composition-api';
import { formatCurrency } from '@/utils/currency';
import bam from '@/lib/bam';
import HrGuidanceEvents from '@/modules/HrGuidance/constants/events';
import { AppEvents } from '@/constants/events';
import useCurrentUser from '@/hooks/useCurrentUser';
import useCurrentCompany from '@/hooks/useCurrentCompany';
import useCurrentPlan from '@/hooks/useCurrentPlan/useCurrentPlan';
import usePlanAccess from '@/hooks/usePlanAccess/usePlanAccess';
import { BillingFeature, BillingPeriod, ProductKey } from '@/gql/generated';

const planInfoConfig = {
  [ProductKey.Lite]: {
    planName: PRODUCT_DISPLAY_NAMES[ProductKey.Lite],
    key: ProductKey.Lite,
    textColorClass: 'text-lite',
    textColorGradientClass: 'text-gradient-lite',
    planHeader:
      '<b>Dedicated HR Manager</b> + Fast HR Direction & Lite-Best Practice Support',
    title: 'Quick HR Clarity. Essential Guidance. Plus, plan the next step.',
    featuresHeader: 'Get started with expert HR support',
    features: [
      '<span class="text-base-900 font-semibold">Your own HR Manager</span> for quick advice when you need it',
      '<span class="text-base-900 font-semibold">10-minute guidance calls</span> to get fast answers',
      '<span class="text-base-900 font-semibold">Platform access</span> to manage your team and track feedback',
      '<span class="text-base-900 font-semibold">Core HR policies</span> and tools for performance management',
    ],
    blurb:
      '<b>Get expert HR support without the big price tag.</b> Everything you need to start building a compliant workplace. Get clarity on HR issues and plan your next steps with confidence.',
  },

  [ProductKey.Core]: {
    planName: PRODUCT_DISPLAY_NAMES[ProductKey.Core],
    key: ProductKey.Core,
    textColorClass: 'text-guidance',
    textColorGradientClass: 'text-gradient-guidance',
    planHeader: 'Dedicated HR Manager + <b>Comprehensive Human Resources</b>.',
    title:
      'Comprehensive Guidance, HR Action Plans, Powerful HR Technology, only on Bambee.',
    featuresHeader:
      'Guidance, Staff Platform & HR Intelligence to Boost Compliance.',
    features: [
      '<span class="text-base-900 font-semibold">See the full details</span> behind every HR issue in your business',
      '<span class="text-base-900 font-semibold">Get step-by-step plans</span> to resolve issues yourself with confidence',
      '<span class="text-base-900 font-semibold">Your dedicated HR Manager</span> helps you move fast and stay compliant',
      '<span class="text-base-900 font-semibold">Custom HR policies</span> built around your culture and goals',
      '<span class="text-base-900 font-semibold">Policy Radar</span> scans your business and flags gaps before they become problems',
      '<span class="text-base-900 font-semibold">Real-time advice</span> when you need it through our powerful platform',
    ],
    blurb:
      "<b>Fix problems the right way.</b> Others give you generic templates. We give you real solutions built for your business. See what's wrong, get clear steps to fix it, and have expert support when you need it.",
  },

  [ProductKey.Elite]: {
    planName: PRODUCT_DISPLAY_NAMES[ProductKey.Elite],
    key: ProductKey.Elite,
    textColorClass: 'text-elite',
    textColorGradientClass: 'text-gradient-elite',
    planHeader:
      'Dedicated HR Manager + <b>Employee Insights & Proactive HR Execution.</b>',
    title:
      "Full Service HR Execution. We Don't Just Tell You What to Do—We Do It for You + All Guidance Plan Benefits.",
    featuresHeader:
      'All Comprehensive Guidance Plan benefits Included. Plus benefits exclusive to Elite:',
    features: [
      '<span class="text-base-900 font-semibold">Delegate HR tasks, like terminations</span> and tough conversations — Bambee handles HR Action Plans, delivering corrective action and more',
      '<span class="text-base-900 font-semibold">Craft HR policies and custom handbooks</span> with dynamic updates—plus, we roll out policies for you to ensure compliance and success.',
      '<span class="text-base-900 font-semibold">Bambee manages employee talks</span> and coaching, while managers get fast, on-demand HR help and support',
      '<span class="text-base-900 font-semibold">Bambee tracks sentiment, issues, resolves them proactively</span> — no waiting. Preventing disputes, boosting performance, + Full report.',
      '<span class="text-base-900 font-semibold">Your HR Manager directly mediates conflicts,</span> drives resolutions, and provides a written completion report.',
      '<span class="text-base-900 font-semibold">Solve big strategic issues</span> with HR Series—set goal, string three calls together. Limited on other plans.',
    ],
    blurb:
      "<b>Bambee delivers what competitors can't.</b> We don't just guide—we do the work for you. Stop spending hours on HR tasks. Your dedicated team handles compliance, employee issues, and policies while you focus on growing your business.",
  },

  [ProductKey.Elite2]: {
    planName: PRODUCT_DISPLAY_NAMES[ProductKey.Elite2],
    key: ProductKey.Elite2,
    textColorClass: 'text-elite',
    textColorGradientClass: 'text-gradient-elite',
    planHeader: 'Dedicated HR Manager + <b>Enhanced Elite Tier Features.</b>',
    title: 'Elite 2 Plan - Enhanced HR Execution + All Elite Benefits.',
    featuresHeader:
      'All Elite Plan benefits Included. Plus enhanced tier benefits:',
    features: [
      '<span class="text-base-900 font-semibold">Everything in Elite</span> plus enhanced capacity for larger teams',
      '<span class="text-base-900 font-semibold">Priority support</span> for faster response times',
      '<span class="text-base-900 font-semibold">More frequent check-ins</span> to catch issues early',
      '<span class="text-base-900 font-semibold">Extra HR Manager availability</span> when you need it most',
    ],
    blurb:
      '<b>Growing fast?</b> Elite 2 gives you more support as your team expands. Same great service with increased capacity and faster response times.',
  },

  [ProductKey.Elite3]: {
    planName: PRODUCT_DISPLAY_NAMES[ProductKey.Elite3],
    key: ProductKey.Elite3,
    textColorClass: 'text-elite',
    textColorGradientClass: 'text-gradient-elite',
    planHeader: 'Dedicated HR Manager + <b>Premium Elite Tier Features.</b>',
    title: 'Elite 3 Plan - Premium HR Execution + All Elite Benefits.',
    featuresHeader:
      'All Elite Plan benefits Included. Plus premium tier benefits:',
    features: [
      '<span class="text-base-900 font-semibold">Everything in Elite</span> plus white-glove service',
      '<span class="text-base-900 font-semibold">Dedicated account manager</span> who knows your business inside and out',
      '<span class="text-base-900 font-semibold">Custom reporting</span> and advanced analytics',
      '<span class="text-base-900 font-semibold">Maximum availability</span> for enterprise-level support',
    ],
    blurb:
      '<b>Premium support for serious growth.</b> Get white-glove service with a dedicated account manager and custom solutions for your enterprise needs.',
  },
};

type PlanNameToPricePoint = {
  [key in ProductKey]?: PricePoint;
};

export default defineComponent({
  name: 'PlanUpgradeModal',
  components: {
    GlowModal,
    PlanUpgradeModalTab,
    TypeBody,
    BaseDivider,
    BaseButton,
    BlockSelector,
    BaseIcon,
    BaseLink,
    AnnularThrobber,
  },
  props: {
    threadId: {
      type: String,
      required: false,
      default: '',
    },
    doNotRefreshPage: {
      type: Boolean,
      required: false,
      default: false,
    },
    defaultTab: {
      type: String as () => ProductKey,
      required: false,
      default: null,
    },
  },
  emits: ['elite-purchased'], // TODO: update. This shouldn't be so specific. maybe we emit something like "purchase" with an argument of elite
  setup(props) {
    const isLoading = ref(false);
    const showDetails = ref(false);

    const { mapPlanToPricePoints, mapPlanToMonthlyPrice, subscribeToPlan } =
      usePlanUpgrade();
    const { currentUser } = useCurrentUser();
    const { companyId } = useCurrentCompany();
    const { currentPlan } = useCurrentPlan();
    const { currentPlan: currentPlanKey } = usePlanAccess();

    const currentTab = ref();
    const annualSelected = ref(false);

    const sortedTabs: ComputedRef<ProductKey[]> = computed(() => {
      const order = [
        ProductKey.Lite,
        ProductKey.Core,
        ProductKey.Elite,
        ProductKey.Elite2,
        ProductKey.Elite3,
      ];

      const tabs = Object.keys(mapPlanToPricePoints.value ?? {})
        .filter((key) => order.includes(key as ProductKey))
        .sort((a, b) => {
          return (
            order.indexOf(a as ProductKey) - order.indexOf(b as ProductKey)
          );
        }) as ProductKey[];

      // Set default tab based on prop, user's current plan, or lowest available upgrade
      if (props.defaultTab && tabs.includes(props.defaultTab)) {
        currentTab.value = props.defaultTab;
      } else if (
        currentPlanKey.value &&
        tabs.includes(currentPlanKey.value as ProductKey)
      ) {
        // Find user's current plan index
        const currentIndex = tabs.indexOf(currentPlanKey.value as ProductKey);
        // Default to next tier up (lowest upgrade), or stay on current if already at highest
        currentTab.value = tabs[currentIndex + 1] ?? tabs[currentIndex];
      } else {
        // No current plan or not in tabs, default to first available (lowest)
        [currentTab.value] = tabs;
      }

      return tabs;
    });

    const plansForTabs = computed<PlanNameToPricePoint>(() => {
      const result: PlanNameToPricePoint = {};

      sortedTabs.value.forEach((productKey) => {
        result[productKey] = mapPlanToPricePoints.value[productKey]?.find(
          (pricePoint) => {
            return productKey === currentPlan.value?.productKey
              ? pricePoint.billingPeriod ===
                  currentPlan.value.billingPeriod.toUpperCase()
              : pricePoint.billingPeriod === BillingPeriod.Month;
          }
        );
      });

      return result;
    });

    const currentBillingFeature = computed(() => {
      return mapPlanToMonthlyPrice.value[currentTab.value].billingFeature;
    });

    const viewingCurrentlySubscribedPlan = computed(() => {
      return planInfoConfig[currentTab.value].key === currentPlanKey.value;
    });

    const handleAnnualSelected = (e) => {
      annualSelected.value = e;
    };

    const onUpgradeClicked = () => {
      isLoading.value = true;

      // Track upgrade button clicked
      bam.trackEvent(AppEvents.PLAN_UPGRADE_BUTTON_CLICKED, {
        selectedPlan: currentTab.value,
        annualSelected: annualSelected.value,
        companyId: companyId.value,
        userId: currentUser.value?._id,
        currentPlanId: currentPlan.value?.value,
        newPlanId: mapPlanToMonthlyPrice.value[currentTab.value].planId,
      });

      // current paradigm is to always subscribe to monthly and then have a
      // BM reach out to upgrade them to annual if they are interested
      if (annualSelected.value) {
        bam.trackEvent(HrGuidanceEvents.ANNUAL_PLAN_REQUESTED, {
          companyId: companyId.value,
          userId: currentUser.value?._id,
          currentPlanId: currentPlan.value?.value,
          newPlanId: mapPlanToMonthlyPrice.value[currentTab.value].planId,
        });
      }
      subscribeToPlan(
        `${mapPlanToMonthlyPrice.value[currentTab.value].planId}`,
        props.threadId as string
      );
    };

    const toggleDetails = (show) => {
      showDetails.value = show;
    };

    // Track tab switching
    watch(currentTab, (newTab, oldTab) => {
      if (oldTab && newTab !== oldTab) {
        bam.trackEvent(AppEvents.PLAN_UPGRADE_TAB_SWITCHED, {
          fromTab: oldTab,
          toTab: newTab,
          companyId: companyId.value,
          userId: currentUser.value?._id,
        });
      }
    });

    return {
      plansForTabs,
      annualSelected,
      handleAnnualSelected,
      currentTab,
      currentBillingFeature,
      sortedTabs,
      planInfoConfig,
      isLoading,
      formatCurrency,
      onUpgradeClicked,
      showDetails,
      toggleDetails,
      viewingCurrentlySubscribedPlan,
      BillingFeature,
    };
  },
});
